import { render } from "./PageTitle.vue?vue&type=template&id=7e39e1ea&ts=true"
import script from "./PageTitle.vue?vue&type=script&lang=ts"
export * from "./PageTitle.vue?vue&type=script&lang=ts"

import "./PageTitle.vue?vue&type=style&index=0&id=7e39e1ea&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__